import React, { useEffect } from 'react'
import Layout from "../layouts/Layout"
import { useNavigate } from "react-router-dom"

export default function Home() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <div></div>
    </Layout>
  )
}
